const getHashQuery = () => {
    const [, search = ''] = window.location.hash.split('?');
    return new URLSearchParams(search);
};

const getSearchQuery = () => new URLSearchParams(window.location.search);

const getUrlQueryParam = (parameter: string): string | null =>
    getHashQuery().get(parameter) ?? getSearchQuery().get(parameter);

const SUPPORTED_LANGUAGE_PATTERN = /^[a-z]{2}(?:-[A-Z]{2})?$/;

export const getLanguageFromUrl = (): string | null => {
    const language = getUrlQueryParam('language');
    if (!language || !SUPPORTED_LANGUAGE_PATTERN.test(language)) {
        return null;
    }
    return language;
};

export const getThemeFromUrl = (): string | null => getUrlQueryParam('theme');
